import { FileUploadFile } from 'primereact/fileupload';
import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { uploadFileAndRetrieveFileUrl } from '../../../../../../api/operations/files/upload-file-and-retrieve-file-url';
import { UserSummaryType } from '../../../../../../api/types/user/user-summary.type';

export const updateAvatarOperations = async (
  userId: number | undefined,
  file: FileUploadFile | undefined,
  setSelectedUser: (user: UserSummaryType) => any,
) => {
  try {
    if (!userId) {
      toast.warn('משהו קרה, נסה שוב בעוד מספר רגעים');
      return;
    }

    if (!file) {
      toast.warn('תחילה יש להעלות קובץ');
      return;
    }

    const fileExtension = file.name.split('.').pop();
    if (!fileExtension?.length) {
      toast.warn(
        'לא ניתן לאתר את סוג הקובץ, נסה להוסיף סיומת לקובץ והעלאה מחדש',
      );
      return;
    }

    const preSignUrlRes = await appApi.getUserAvatarPreSignUrl(
      userId,
      fileExtension,
    );

    const fullUrl = await uploadFileAndRetrieveFileUrl(
      preSignUrlRes.data.body,
      file,
    );

    if (!fullUrl) {
      throw new Error('Can not find uploaded path');
    }

    const uploadAvatarImageRes = await appApi.uploadUserAvatarPreSignUrl(
      userId,
      fullUrl,
    );

    setSelectedUser((prev) => {
      if (!prev) return prev;
      return { ...prev, fileUrl: fullUrl };
    });
  } catch (e) {
    console.error(
      `updateAvatarOperations is failed with the userId: ${userId} and the error: ${e}`,
    );
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
